import React from 'react';

import DataConnector from 'connect/DataConnector';
import Toast from 'nav/toasts/Toast';
import {RenderedToast} from 'nav/toasts/ToastConstants';
import ToastStore from 'nav/toasts/ToastStore';

interface ToastsContainerProps {
  toasts: Array<RenderedToast>;
}

class ToastsContainerConnector extends DataConnector<{}, ToastsContainerProps> {
  override shouldSubscribeToRedux = false;
  override stores = [ToastStore];

  enhanceProps(): ToastsContainerProps {
    return {toasts: this.toastStore().getToasts()};
  }
}

function ToastsContainer(props: ToastsContainerProps): JSX.Element {
  return (
    <div>
      {props.toasts.map((toast) => (
        <Toast
          id={toast.id}
          actions={toast.actions}
          actionText={toast.actionText}
          clipboardData={toast.clipboardData}
          isCloseable={toast.isCloseable}
          key={toast.id}
          message={toast.message}
          onActionClick={toast.onActionClick}
          onClose={toast.onClose}
          progress={toast.progress}
          skipCloseCallbackOnActions={toast.skipCloseCallbackOnActions}
          type={toast.type}
        />
      ))}
    </div>
  );
}

export default ToastsContainerConnector.connect(ToastsContainer);
